/**
 * Internal dependencies
 */

import { applyFilters } from '@wordpress/hooks'
import Block from './block'
import renderFrontend from '../../util/render-frontend.js'
import './common'

const getProps = el => ( {
	attributes: JSON.parse( el.dataset.attributes ),
	hasVisibilitySensor: applyFilters( 'cartzillagb.brands.disable.visibility.sensor', true ),
} )

renderFrontend(
	'.wp-block-czgb-brands div.ajax-content',
	Block,
	getProps
)
